import React from 'react'

import { object } from 'prop-types'

function DashboardSummary({ meta, data }) {
  if (!data) return null
  return (
    <div className="dashboard-summary mb-4">
      <div className="dashboard-stats">
        <div className="stat-item">
          <span className="stat-label">Total models:</span>
          <span className="stat-value">{meta?.totalUnfilteredCount || 0}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Published models:</span>
          <span className="stat-value">{data?.models_count || 0}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Average publishing score:</span>
          <span className="stat-value">
            {data?.average_publish_score?.toFixed(1) || 0}
          </span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Average CGT Standard score:</span>
          <span className="stat-value">
            {data?.flamingo_average?.toFixed(1) || 0} %
          </span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Positive reviews:</span>
          <span className="stat-value">
            {data?.positive_rating_count || 0}
          </span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Negative reviews:</span>
          <span className="stat-value">
            {data?.negative_rating_count || 0}
          </span>
        </div>
      </div>
    </div>
  )
}

DashboardSummary.propTypes = {
  meta: object.isRequired,
  data: object.isRequired,
}

export default DashboardSummary
